import { StarIcon } from "@assets/Icons";
import styles from "./styles.module.scss";

export const FeaturesList = ({isWalky}) => (
  <ul className={styles.featuresList}>
    <li>
      <StarIcon color={isWalky ? '#E7394F' : undefined} />
      Abs workouts according to your body type
    </li>
    <li>
      <StarIcon color={isWalky ? '#E7394F' : undefined}/>
      Personalized plans to boost your results
    </li>
    <li>
      <StarIcon color={isWalky ? '#E7394F' : undefined}/>
      Unique workouts to improve your sexual energy
    </li>
    <li>
      <StarIcon color={isWalky ? '#E7394F' : undefined}/>
      Auto-renewal plans, cancel anytime
    </li>
  </ul>
);
